<template>
  <div class="flex flex-wrap -mb-8 -mr-6 p-8">
    <select-dropdown
      v-model="form.actual_location_type" :error="form.errors.actual_location_type"
      class="pr-6 pb-8 w-full lg:w-1/2" :options="types" :label="$t('applicants.type')"
      :required="true"
    />
    <select-dropdown
      v-if="showPrison" v-model="form.actual_location_id" :error="form.errors.actual_location_id"
      class="pr-6 pb-8 w-full lg:w-1/2" :options="locations" :label="$t('applicants.prison')"
      :required="requiredLocation"
    />
    <text-input
      v-if="emptyLocationField"
      v-model="form.actual_location_name"
      :error="form.errors.actual_location_name"
      class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('interventions.location_specify')"
      :required="requiredName"
    />
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import SelectDropdown from '@/Shared/SelectDropdown'
import find from 'lodash/find'

export default {
  components: {
    TextInput,
    SelectDropdown,
  },
  props: ['formData', 'locations', 'types'],
  data() {
    return {
      requiredLocation: false,
      requiredName: false,
    }
  },
  computed: {
    form() {
      return this.formData
    },
    currentType() {
      return this.form.actual_location_type
    },
    emptyLocationField() {
      if (this.form.actual_location_type === 3) {
        return true
      }
      let field = find(this.locations, { id: this.form.actual_location_id })
      if (field) {
        return field.empty_field
      }
      return false

    },
    showPrison() {
      if (this.form.actual_location_type === 1) {
        return true
      }
      return false
    },
  },
  watch: {
    currentType(val) {
      if (val === 1) {
        this.form.actual_location_name = null
      } else if (val === 2) {
        this.form.actual_location_name = null
        this.form.actual_location_id = null
      } else if (val === 3) {
        this.form.actual_location_id = null
      }
      this.setCorrectFields()
    },
    emptyLocationField(){
      if (this.emptyLocationField) {
        this.requiredName = true
      } else {
        this.requiredName = false
      }
    }
  },
  mounted() {
    this.setCorrectFields()
  },
  methods: {
    setCorrectFields() {
      if (this.form.actual_location_type === 1) {
        if (this.emptyLocationField) {
          this.requiredName = true
        } else {
          this.requiredName = false
        }
        this.requiredLocation = true
      } else if (this.form.actual_location_type === 3) {
        this.requiredLocation = false
        this.requiredName = true
      } else {
        this.requiredLocation = false
        this.requiredName = false
      }
    },
  },
}
</script>
